import { debounce } from 'lodash'
import get from 'lodash.get'
import {
  Dawning_of_a_New_Day,
  Herr_Von_Muellerhoff,
  Nothing_You_Could_Do,
  Over_the_Rainbow,
  Zeyada,
} from 'next/font/google'

const nothingYouCouldDoFont = Nothing_You_Could_Do({
  weight: '400',
  subsets: ['latin'],
  preload: true,
})

const zeyadaFont = Zeyada({
  weight: '400',
  subsets: ['latin'],
  preload: true,
})

const dawningOfANewDayFont = Dawning_of_a_New_Day({
  preload: true,
  weight: '400',
  subsets: ['latin'],
})

const herrVonMuellerhoff = Herr_Von_Muellerhoff({
  weight: '400',
  subsets: ['latin'],
  preload: true,
})

const overTheRainbowFont = Over_the_Rainbow({
  preload: true,
  weight: '400',
  subsets: ['latin'],
})

export const signatureFonts = [
  nothingYouCouldDoFont,
  zeyadaFont,
  dawningOfANewDayFont,
  herrVonMuellerhoff,
  overTheRainbowFont,
]
